module.exports = __webpack_public_path__ + "assets/pdf/E04-cn-beijing-haze.62da384c.pdf";